// extracted by mini-css-extract-plugin
export default {"root_image_inner":"finishForm_root_image_inner__kLlvY"};